export default "__VITE_ASSET__DXwbs6es__"